module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: [_vm.custom ? 'custom-file' : null, _vm.inputClass],
    on: {
      "dragover": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.dragover($event)
      }
    }
  }, [(_vm.dragging) ? _c('span', {
    staticClass: "drop-here",
    attrs: {
      "data-drop": _vm.dropLabel
    },
    on: {
      "dragover": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.dragover($event)
      },
      "drop": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.drop($event)
      },
      "dragleave": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.dragging = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "input",
    staticClass: "custom-file-input",
    attrs: {
      "type": "file",
      "name": _vm.name,
      "id": _vm._id,
      "disabled": _vm.disabled,
      "accept": _vm.accept,
      "multiple": _vm.multiple,
      "webkitdirectory": _vm.directory
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), (_vm.custom) ? _c('span', {
    class: ['custom-file-control', _vm.dragging ? 'dragging' : null, _vm.inputClass],
    attrs: {
      "data-choose": _vm.computedChooseLabel,
      "data-selected": _vm.selectedLabel
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e062816"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/components/form-file.vue
// module id = 239
// module chunks = 0